import SAPOMailConfig from "@/SAPOMailConfig";
import HTTPService    from "@/js/Shared/Services/HTTP/HTTPService";

export { AntiSpamHTTPService as default };

/**
* Email antispam HTTP Service
*
* @author      Rúben Simoes <ruben.r.simoes@meo.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class AntiSpamHTTPService
{
  /**
   * Contacts Enpoint
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  endpoint = SAPOMailConfig.client.endpoints.settings.imp;

    /**
     * Calls backend api to fetch antispam settings
     *
     * @public
     *
     * @since 7.0.0
     *
     * @return {Promise.<HTTPResponseEntity>}
     */
    async fetchWhitelist() {
        let response = await HTTPService.post(
            this.endpoint + '/antiSpam',
            {
                'op' : 'whitelistGet',
            },
            'fetch_whitelist_list',
        );

        return response;
    }

    /**
     * Calls backend api to remove email from whitelist antispam
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {string} sender  email to be removed from whitelist
     *
     * @return {Promise.<HTTPResponseEntity>}
    */
    async removeWhitelistSender(sender) {
        let response = await HTTPService.post(
            this.endpoint + '/antiSpam',
            {
                'op' : 'whitelistDeleteSender',
                'params': {
                'sender': sender
                }
            },
            `remove_sender_blacklist_${sender}`,
        );

        return response;
    }

    /**
     * Calls backend api to add email to whitelist antispam
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {Object} senders senders to be added to whitelist
     *
     * @return {Promise.<HTTPResponseEntity>}
    */
    async addWhitelistSender(senders) {
        let response = await HTTPService.post(
            this.endpoint + '/antiSpam',
            {
                'op' : 'whitelistAddSender',
                'params': {
                'senders': JSON.stringify(senders)
                }
            },
            `add_sender_whitelist`,
        );
        return response;
    }

 /**
     * Calls backend api to fetch antispam settings
     *
     * @public
     *
     * @since 7.0.0
     *
     * @return {Promise.<HTTPResponseEntity>}
     */
    async fetchBlacklist() {
        let response = await HTTPService.post(
            this.endpoint + '/antiSpam',
            {
                'op' : 'blacklistGet',
            },
            'fetch_blacklist_list',
        );

        return response;
    }

    /**
     * Calls backend api to remove email from whitelist antispam
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {string} sender  email to be removed from whitelist
     *
     * @return {Promise.<HTTPResponseEntity>}
    */
    async removeBlacklistSender(sender) {
        let response = await HTTPService.post(
            this.endpoint + '/antiSpam',
            {
                'op' : 'blacklistDeleteSender',
                'params': {
                'sender': sender
                }
            },
            `remove_sender_blacklist_${sender}`,
        );

        return response;
    }

    /**
     * Calls backend api to add email to whitelist antispam
     *
     * @public
     *
     * @since 7.0.0
     *
     * @param {Object} senders senders to be added to blacklist
     *
     * @return {Promise.<HTTPResponseEntity>}
    */
    async addBlacklistSender(senders) {
        let response = await HTTPService.post(
            this.endpoint + '/antiSpam',
            {
                'op' : 'blacklistAddSender',
                'params': {
                'senders': JSON.stringify(senders)
                }
            },
            `add_sender_blacklist`,
        );
        return response;
    }
}